import { render, staticRenderFns } from "./GithubFeed.vue?vue&type=template&id=9c36ad72&"
import script from "./GithubFeed.vue?vue&type=script&lang=js&"
export * from "./GithubFeed.vue?vue&type=script&lang=js&"
import style0 from "./GithubFeed.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports